var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.112,
    height: 22.062,
    viewBox: "0 0 22.112 22.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1654.2,214.914a2.068,2.068,0,0,0,.578,1.447l.042.041a2.008,2.008,0,0,0,2.81-.041l4.132-4.133a1.967,1.967,0,0,0,.579-1.4,3.805,3.805,0,0,0-.124-.578l1.446-1.447a7.831,7.831,0,0,0,12.645-6.157,7.623,7.623,0,0,0-2.272-5.455,7.782,7.782,0,0,0-11.034,0,7.618,7.618,0,0,0-2.273,5.5,7.868,7.868,0,0,0,1.653,4.835l-1.446,1.447a1.315,1.315,0,0,0-.579-.124,2.064,2.064,0,0,0-1.446.578l-4.133,4.133a1.787,1.787,0,0,0-.578,1.363m8.058-12.273a6.24,6.24,0,1,1,1.818,4.38,6.369,6.369,0,0,1-1.818-4.38m-6.364,12.6a.434.434,0,0,1,0-.537l4.133-4.133c.082-.124.165-.124.289-.124a.376.376,0,0,1,.289.124.584.584,0,0,1,.083.248.376.376,0,0,1-.124.29l-4.133,4.132a.434.434,0,0,1-.537,0m8.513-12.108a.8.8,0,0,0,.868-.744,3.714,3.714,0,0,1,.289-1.116,3.022,3.022,0,0,1,.661-.95,3.28,3.28,0,0,1,1.653-.909,3.344,3.344,0,0,1,1.9.165.813.813,0,0,0,.827-.372.848.848,0,0,0-.248-1.157,5.041,5.041,0,0,0-2.81-.206,4.673,4.673,0,0,0-2.521,1.322,4.819,4.819,0,0,0-.992,1.4,4.089,4.089,0,0,0-.413,1.694.8.8,0,0,0,.785.868",
    transform: "translate(-1654.197 -194.893)",
    fill: "#575756"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2016552ee9405b9762d96d1fe1f72621.svg";
export { ForwardRef as ReactComponent };